@let isLoading = isLoading$ | async;
@let filteredHistoryLogs = $filteredHistoryLogs();
@let sortedBy = $sortedBy();
@let sortedDirection = $sortedDirection();

<style>
  table {
    border-collapse: collapse;
    border-spacing: 0 8px;
    overflow-x: auto;
  }
  th {
    background-color: var(--tui-background-base-alt);
    border-top: none;
    padding-bottom: 10px;
  }
  th:first-child {
    border-left: none;
  }
  th:last-child {
    border-right: none;
  }
  td {
    border-inline-start: none;
    border-inline-end: none;
    border-color: rgba(73, 76, 98, 0.05);
    background-color: var(--tui-background-base-alt);
  }
  tui-chip {
    height: 24px;
  }
</style>
<div
  class="x-card x-card_size_l p-[20px] pt-[10px] mx-[20px] mb-10 mt-10 x-white"
  [tuiSkeleton]="!!(isLoading && isInitialLoad)"
>
  <table tuiTable class="w-full" [columns]="tableColumns">
    <thead>
      <tr tuiThGroup>
        <th
          tuiTh
          [resizable]="true"
          class="x-font-body-5-bold cursor-pointer! select-none"
          (click)="sort('action')"
        >
          <div class="flex items-center gap-1">
            {{
              'request_form.request_change_logs.table_col_action' | translate
            }}
            <tui-icon
              [ngClass]="{ 'opacity-100!': sortedBy === 'action' }"
              class="opacity-30 size-6 text-base"
              [icon]="
                sortedDirection === 'asc'
                  ? '@tui.chevron-up'
                  : '@tui.chevron-down'
              "
            />
          </div>
        </th>

        <th
          tuiTh
          [resizable]="true"
          class="x-font-body-5-bold cursor-pointer! select-none"
          (click)="sort('userId.fullname')"
        >
          <div class="flex items-center gap-1">
            {{ 'request_form.request_change_logs.table_col_user' | translate }}
            <tui-icon
              [ngClass]="{ 'opacity-100!': sortedBy === 'userId.fullname' }"
              class="opacity-30 size-6 text-base"
              [icon]="
                sortedDirection === 'asc'
                  ? '@tui.chevron-up'
                  : '@tui.chevron-down'
              "
            />
          </div>
        </th>
        <th
          tuiTh
          [resizable]="true"
          class="x-font-body-5-bold cursor-pointer! select-none"
          (click)="sort('context')"
        >
          <div class="flex items-center gap-1">
            {{ 'request_form.request_change_logs.table_col_info' | translate }}
            <tui-icon
              [ngClass]="{ 'opacity-100!': sortedBy === 'context' }"
              class="opacity-30 size-6 text-base"
              [icon]="
                sortedDirection === 'asc'
                  ? '@tui.chevron-up'
                  : '@tui.chevron-down'
              "
            />
          </div>
        </th>
        <th
          tuiTh
          [resizable]="true"
          class="x-font-body-5-bold cursor-pointer! select-none"
          (click)="sort('createdAt')"
        >
          <div class="flex items-center gap-1">
            {{ 'request_form.request_change_logs.table_col_when' | translate }}
            <tui-icon
              [ngClass]="{ 'opacity-100!': sortedBy === 'createdAt' }"
              class="opacity-30 size-6 text-base"
              [icon]="
                sortedDirection === 'asc'
                  ? '@tui.chevron-up'
                  : '@tui.chevron-down'
              "
            />
          </div>
        </th>
      </tr>
    </thead>
    <tbody tuiTbody [data]="filteredHistoryLogs">
      @for (log of filteredHistoryLogs; track log.id) {
        <tr tuiTr>
          <td *tuiCell="'table_col_action'" tuiTd>
            <div class="flex items-center gap-2">
              <span
                tuiChip
                size="xs"
                class="x-font-body-5-bold"
                [ngClass]="{
                  'bg-[#4283c1]!': log.action === RequestLogActionEnum.CREATE,
                  'bg-[#ecaf68]!': log.action === RequestLogActionEnum.UPDATE,
                  'bg-[red]!': log.action === RequestLogActionEnum.DELETE,
                  'bg-[#494C62FF]!': log.action === RequestLogActionEnum.NOTIFY,
                }"
              >
                <span class="x-text-primary">{{
                  'request_form.request_change_logs.' + (log.action | lowercase)
                    | translate
                }}</span>
              </span>
              @if (
                log.action === RequestLogActionEnum.UPDATE &&
                log.entity === 'Заявки' &&
                log.context.indexOf('Изменил заявку') === 0
              ) {
                <tui-icon
                  [style.border-width.rem]="0.25"
                  icon="@tui.table-merge"
                  class="cursor-pointer"
                  (click)="compareLogModal(log.id, compareLogsModalContent)"
                />
              }
            </div>
          </td>

          <td
            *tuiCell="'table_col_user'"
            tuiTd
            class="x-font-body-5-bold-important"
          >
            {{ log.userId.fullname }}
          </td>
          <td *tuiCell="'table_col_info'" tuiTd class="x-font-body-5-important">
            {{ log.context }}
          </td>
          <td
            *tuiCell="'table_col_when'"
            tuiTd
            class="x-font-body-5-important cursor-pointer"
            [tuiHint]="log.createdAt | date: 'medium'"
            tuiHintAppearance="dark"
            [tuiHintHideDelay]="0"
          >
            {{ log.createdAtAgo }}
          </td>
        </tr>
      } @empty {
        <tr>
          <td colspan="100%" class="border-none!" tuiTd>
            <x-empty-block
              [title]="
                'request_form.request_change_logs.nothing_found' | translate
              "
            />
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>

<ng-template #compareLogsModalContent>
  <div class="x-card x-card_size_l x-white">
    <div class="x-card__content">
      <div>
        <h3 class="x-card__title x-font-body-1-bold">
          {{
            'request_form.request_change_logs.comparing_modal_header'
              | translate
          }}
        </h3>
        <p class="x-card__paragraph" [innerHTML]="$comparingLogsData()"></p>
        <button
          appearance="flat"
          size="m"
          tuiButton
          type="button"
          class="x-card__footer-button"
          (click)="changeComparingLogsAlgorithm()"
        >
          {{
            'request_form.request_change_logs.comparing_modal_change_algorithm_button'
              | translate
          }}
        </button>
      </div>
    </div>
  </div>
</ng-template>
